export default __webpack_public_path__ + "static/media/contactMe.aef54a49.jpg";